export default {
  MINIMUM: 30,
  MEDIUM: 50,
  MAXIMUM: 100,
};
